export function initialCollection (overrides) {
  return {
    ids: [],
    entities: {},
    loaded: false,
    loading: false,
    selectedEntityId: null,
    ...overrides
  }
}

const FETCHALL = 'FETCHALL'
const LOADING = 'LOADING'
const SELECT = 'SELECT'

const getters = {
  all: state => state.ids.map(id => state.entities[id]),
  selected: state => state.entities[state.selectedEntityId]
}

const mutations = {
  [FETCHALL] (state, { ids, entities, loaded }) {
    state.entities = entities
    state.ids = ids
    state.loaded = !!loaded
    state.loading = false
    state.selectedEntityId = ids[0]
  },
  [LOADING] (state) {
    state.loading = true
  },
  [SELECT] (state, id) {
    state.selectedEntityId = id
  }
}

export function createCollection (config) {
  const actions = {
    fetchAll ({ commit }) {
      return new Promise((resolve, reject) => {
        commit(LOADING)
        let collection = { ids: [], entities: {} }
        config.fetchAll.request()
          .then(response => {
            collection = config.fetchAll.processResponse(response)
            commit(FETCHALL, collection)
            resolve()
          })
          .catch(error => {
            commit(FETCHALL, collection)
            reject(error.request || error)
          })
      })
    },
    select ({ commit, dispatch, state }, id) {
      return new Promise((resolve, reject) => {
        if (!state.entities[id]) {
          dispatch('fetchAll').then(() => {
            if (state.entities[id]) {
              commit(SELECT, id)
              resolve()
            } else {
              reject()
            }
          })
        } else {
          commit(SELECT, id)
          resolve()
        }
      })
    }
  }

  return {
    namespaced: true,
    state: initialCollection(),
    getters,
    actions,
    mutations
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/collection.js